import type { EEventsShortcut } from "@/core/@types/types";
import { IMapNamesShortcut } from "@/core/composables/types";

export enum EShortcutsDateIndicadores {
  "ultimos7dias" = 0,
  "mesPassado" = 1,
  "esteMes" = 2,
  "acumulado30dias" = 3,
  "hoje" = 5,
  "ontem" = 6,
  "proximos30Dias" = 7,
  "ultimos90Dias" = 8,

  "semanaPassada" = 9,
  "essaSemana" = 10,
  "anoPassado" = 11,
  "esteAno" = 12,
  "ultimos12Meses" = 13,

  "proximos60Dias" = 14,
  "proximos90Dias" = 15,
  "proximos12Meses" = 16
}

export enum EShortcutsDateContabil {
  "Ano2022" = 2022,
  "Ano2023" = 2023
}

export enum EshortCutShared {
  "custom" = 4
}

export type EShortcutsDate<T> = EshortCutShared | T;

export interface IDateRange {
  start?: string;
  end?: string;
  formatedDate: {
    start?: string;
    end?: string;
  };
}

export interface IShortcutEmits {
  (
    event: EEventsShortcut.shortcutUpdate,
    shortcut: IDateRange | undefined
  ): void;
  (
    event: EEventsShortcut.shortcutCustom,
    shortcut: IDateRange | undefined
  ): void;
  (event: EEventsShortcut.notifyChange, shortcutId: number | undefined): void;
  (
    event: EEventsShortcut.updateShortcutFilter,
    shortcutId: number | undefined,
    shortcut?: IDateRange | undefined
  ): void;
}

export interface IShortcutHandler<T> {
  handle(shortcut: EShortcutsDate<T>): IDateRange | undefined;
  shortcutNames: IMapNamesShortcut<T>;
  shortcuts: Map<EShortcutsDate<T>, IDateRange>;
  // setShortcuts(): void
}
